import axios from 'axios';
import type { Solicitacao } from '@eleg360/types';

export interface SolicitacaoEvento {
  id: string;
  tenant_id: string;
  solicitacao_id: string;
  tipo: string;
  descricao: string;
  actor_id: string;
  metadata: Record<string, any>;
  created_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const solicitacoesApi = {
  create: async (
    data: {
      contato_id: string;
      tema: string;
      descricao: string;
      prioridade: 'baixa' | 'media' | 'alta' | 'urgente';
      canal: 'presencial' | 'whatsapp' | 'telefone' | 'email' | 'online';
      lideranca_origem_id?: string;
      sla_prazo?: string;
      responsavel_id?: string;
      anexos?: string[];
    },
    token: string,
  ) => {
    const res = await axios.post<Solicitacao>(`${API_URL}/gab/solicitacoes`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  list: async (filters: Record<string, any>, token: string) => {
    const res = await axios.get<Solicitacao[]>(`${API_URL}/gab/solicitacoes`, {
      params: filters,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Solicitacao>(`${API_URL}/gab/solicitacoes/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getEvents: async (id: string, token: string) => {
    const res = await axios.get<SolicitacaoEvento[]>(`${API_URL}/gab/solicitacoes/${id}/eventos`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  update: async (
    id: string,
    data: {
      status?: 'nova' | 'em_analise' | 'encaminhada' | 'concluida';
      prioridade?: 'baixa' | 'media' | 'alta' | 'urgente';
      responsavel_id?: string;
      descricao?: string;
      anexos?: string[];
    },
    token: string,
  ) => {
    const res = await axios.put<Solicitacao>(`${API_URL}/gab/solicitacoes/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  addComentario: async (id: string, texto: string, token: string) => {
    const res = await axios.post<SolicitacaoEvento>(
      `${API_URL}/gab/solicitacoes/${id}/comentarios`,
      { texto },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/solicitacoes/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
